import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Header from 'components/Header'
import Rail from 'components/Rail'
import RailLeft from 'components/RailLeft'
import Footer from 'components/Footer'
import PageLoader from 'components/PageLoader'
import SearchResult from 'components/SearchResult'
import { getSearchTerm } from 'modules/home/HomeSelector'

import styles from './FormLayout.module.sass'
import stylesRD from 'components/Rail/RailDual.module.sass'

const crypto = window.crypto || window.msCrypto
let random = new Uint32Array(1)
const isActivationKey = key => key === 'Enter' || key === ' '

const FormLayout = ({ children, loading }) => {
  const searchTerm = useSelector(getSearchTerm)
  const [menuOpen, setMenuOpen] = useState(false)

  const isSearching = Boolean(searchTerm?.length)

  const closeMenu = useCallback(() => {
    setMenuOpen(crypto?.getRandomValues(random)[0])
  }, [])

  const closeMenuFromEvent = useCallback(
    e => {
      if (!e || e.type === 'click' || isActivationKey(e.key)) {
        closeMenu(crypto?.getRandomValues(random)[0])
      }
    },
    [closeMenu]
  )

  const railContent = useMemo(() => {
    if (isSearching) return <SearchResult />
    return children
  }, [children, isSearching])

  return (
    <>
      <div className={styles.box}>
        <Header menuOpen={menuOpen} />
        <div className={styles.gap}></div>
        <div
          role="button"
          tabIndex={0}
          data-testid="result"
          className={styles.content}
          onClick={closeMenuFromEvent}
          onKeyDown={closeMenuFromEvent}
        >
          <RailLeft />
          <Rail styles={stylesRD}>{railContent}</Rail>
        </div>
        {loading && <PageLoader />}
      </div>
      <Footer setMenuOpen={closeMenu} />
    </>
  )
}

FormLayout.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool
}

export default FormLayout
